import React, { useReducer, createContext, useCallback, useEffect } from "react";

import { v4 as uuidv4 } from "uuid";
import { useCookies } from "react-cookie";
// import { useAuth } from "utils/AuthProvider";
import SnackbarAlert from "components/SnackbarAlert";

import * as types from "./dataReducer";
import dataReducer from "./dataReducer";

const axios = require("axios").default;

export const API_URL = "https://super.mind.plus";
//export const API_URL = "http://localhost:5005";
// export const API_URL = 'http://192.168.1.50:5000'

// import accountGroupsData from "../demo_data/accountGroupsData.json";
// import allStamps from "../demo_data/stamp.json";

function uuidvNumbers() {
  const uuid = uuidv4();
  const uuidFinal = uuid.replace(/\D/g, "").slice(0, 12);
  return Number(uuidFinal);
}
const initialState = {
  all_programs: [],
  all_sessions: [],
  all_soundscapes: [],
  all_sleep_programs: [],
  all_breathe_programs: [],
  all_video_programs: [],
  all_users: [],
  all_doctor: [],
  all_patients: [],
  ipd_patients: [],
  opd_patients: [],
  all_articles: [],
  all_categories: [],
  all_tags: [],
  all_quotes: [],
  all_journal_questions: [],

  snackbar_alert: { color: "error", title: "", errorSB: false },
};

export const DataContext = createContext(initialState);
export const UserProvider = ({ children }) => {
  const [dataState, dispatch] = useReducer(dataReducer, initialState);
  const [cookies, setCookies, removeCookie] = useCookies();

  let headerWithToken = {
    headers: {
      Authorization: `Bearer ${cookies.token}`,
      Accept: "*/*",
      "Content-Type": "application/json",
    },
  };

  const closeSnackbarAlert = () => {
    dispatch({ type: types.HIDE_SNACKBAR_ALERT, payload: false });
  };

  const myDispatch = (key, value) => {
    dispatch({ type: key, payload: value });
  };

  const getUsersApi = useCallback(async () => {
    axios
      .get(`${API_URL}/api/users`, headerWithToken)
      .then(function (response) {
        // console.log('response.data', response.data);
        dispatch({ type: types.SET_ALL_USERS, payload: response.data });
      })
      .catch(function (error) {
        // console.log('Something went wrong')
        // console.log(error)
      });
  }, []);

  const getDoctorUsersApi = useCallback(async () => {
    axios
      .post(`${API_URL}/api/users/doctors`, headerWithToken)
      .then(function (response) {
        // console.log('response.data', response.data);
        dispatch({ type: types.SET_ALL_DOCTORS, payload: response.data });
      })
      .catch(function (error) {
        // console.log('Something went wrong')
        // console.log(error)
      });
  }, []);

  const getPatientsApi = useCallback(async () => {
    axios
      .get(`${API_URL}/api/patients`, headerWithToken)
      .then(function (response) {
        // console.log('response.data', response.data);
        dispatch({ type: types.SET_ALL_PATIENTS, payload: response.data });
      })
      .catch(function (error) {
        // console.log('Something went wrong')
        // console.log(error)
      });
  }, []);

  const getIPDPatientsApi = useCallback(async () => {
    axios
      .get(`${API_URL}/api/patients/type/IPD`, headerWithToken)
      .then(function (response) {
        // console.log('response.data', response.data);
        dispatch({ type: types.SET_IPD_PATIENTS, payload: response.data });
      })
      .catch(function (error) {
        // console.log('Something went wrong')
        // console.log(error)
      });
  }, []);

  const getOPDPatientsApi = useCallback(async () => {
    axios
      .get(`${API_URL}/api/patients/type/OPD`, headerWithToken)
      .then(function (response) {
        // console.log('response.data', response.data);
        dispatch({ type: types.SET_OPD_PATIENTS, payload: response.data });
      })
      .catch(function (error) {
        // console.log('Something went wrong')
        // console.log(error)
      });
  }, []);

  const getProgramsApi = useCallback(async () => {
    axios
      .get(`${API_URL}/api/programs`, headerWithToken)
      .then(function (response) {
        // console.log('response.data', response.data);
        dispatch({ type: types.SET_ALL_PROGRAMS, payload: response.data });
      })
      .catch(function (error) {
        // console.log('Something went wrong')
        // console.log(error)
      });
  }, []);

  const getSoundscapesApi = useCallback(async () => {
    axios
      .get(`${API_URL}/api/soundscapes`, headerWithToken)
      .then(function (response) {
        // console.log('response.data', response.data);
        dispatch({ type: types.SET_ALL_SOUNDSCAPES, payload: response.data });
      })
      .catch(function (error) {
        // console.log('Something went wrong')
        // console.log(error)
      });
  }, []);

  const getSleepsApi = useCallback(async () => {
    axios
      .get(`${API_URL}/api/sleepprograms`, headerWithToken)
      .then(function (response) {
        // console.log('response.data', response.data);
        dispatch({ type: types.SET_ALL_SLEEP_PROGRAMS, payload: response.data });
      })
      .catch(function (error) {
        // console.log('Something went wrong')
        // console.log(error)
      });
  }, []);

  const getBreathesApi = useCallback(async () => {
    axios
      .get(`${API_URL}/api/breatheprograms`, headerWithToken)
      .then(function (response) {
        // console.log('response.data', response.data);
        dispatch({ type: types.SET_ALL_BREATHE_PROGRAMS, payload: response.data });
      })
      .catch(function (error) {
        // console.log('Something went wrong')
        // console.log(error)
      });
  }, []);

  const getQuotesApi = useCallback(async () => {
    axios
      .get(`${API_URL}/api/quotes`, headerWithToken)
      .then(function (response) {
        // console.log('response.data', response.data);
        dispatch({ type: types.SET_ALL_QUOTES, payload: response.data });
      })
      .catch(function (error) {
        // console.log('Something went wrong')
        // console.log(error)
      });
  }, []);

  const getQuestionsApi = useCallback(async () => {
    axios
      .get(`${API_URL}/api/journalingquestions`, headerWithToken)
      .then(function (response) {
        // console.log('response.data', response.data);
        dispatch({ type: types.SET_ALL_JOURNAL_QUESTIONS, payload: response.data });
      })
      .catch(function (error) {
        // console.log('Something went wrong')
        // console.log(error)
      });
  }, []);

  const getArticlesApi = useCallback(async () => {
    axios
      .get(`${API_URL}/api/articles`, headerWithToken)
      .then(function (response) {
        // console.log('response.data', response.data);
        dispatch({ type: types.SET_ALL_ARTICLES, payload: response.data });
      })
      .catch(function (error) {
        // console.log('Something went wrong')
        // console.log(error)
      });
  }, []);

  // const getSessionsApi = useCallback(async (reqId) => {
  //   axios
  //     .post(
  //       `${API_URL}/api/programs/sessions`,
  //       {
  //         program: reqId,
  //       },
  //       headerWithToken
  //     )
  //     .then(function (response) {
  //       // console.log('response.data', response.data);
  //       dispatch({ type: types.SET_ALL_SESSIONS, payload: response.data });
  //     })
  //     .catch(function (error) {
  //       // console.log('Something went wrong')
  //       // console.log(error)
  //     });
  // }, []);

  const getSessionsApi = useCallback(async (reqId) => {
    try {
      const res = await axios.post(
        `${API_URL}/api/programs/sessions`,
        {
          program: reqId,
        },
        headerWithToken
      );
      dispatch({ type: types.SET_ALL_SESSIONS, payload: res.data });
      return { success: true, data: res };
    } catch (error) {
      // console.log('asdasasdas', res);
      return { success: false };
    }
  }, []);

  const getSingleProgramApi = useCallback(async (reqId) => {
    try {
      const res = await axios.post(
        `${API_URL}/api/programs/program`,
        {
          id: reqId,
        },
        headerWithToken
      );
      return { success: true, data: res };
    } catch (error) {
      // console.log('asdasasdas', res);
      return { success: false };
    }
  }, []);

  const getSingleSoundscapeApi = useCallback(async (reqId) => {
    try {
      const res = await axios.post(
        `${API_URL}/api/soundscapes/soundscape`,
        {
          id: reqId,
        },
        headerWithToken
      );
      return { success: true, data: res };
    } catch (error) {
      // console.log('asdasasdas', res);
      return { success: false };
    }
  }, []);

  const getSingleSleepApi = useCallback(async (reqId) => {
    try {
      const res = await axios.post(
        `${API_URL}/api/sleepprograms/sleepprogram`,
        {
          id: reqId,
        },
        headerWithToken
      );
      return { success: true, data: res };
    } catch (error) {
      // console.log('asdasasdas', res);
      return { success: false };
    }
  }, []);

  const getSingleBreatheApi = useCallback(async (reqId) => {
    try {
      const res = await axios.post(
        `${API_URL}/api/breatheprograms/breatheprogram`,
        {
          id: reqId,
        },
        headerWithToken
      );
      return { success: true, data: res };
    } catch (error) {
      // console.log('asdasasdas', res);
      return { success: false };
    }
  }, []);

  const getSingleQuoteApi = useCallback(async (reqId) => {
    try {
      const res = await axios.post(
        `${API_URL}/api/quotes/quote`,
        {
          id: reqId,
        },
        headerWithToken
      );
      return { success: true, data: res };
    } catch (error) {
      // console.log('asdasasdas', res);
      return { success: false };
    }
  }, []);

  const getSingleQuestionApi = useCallback(async (reqId) => {
    try {
      const res = await axios.post(
        `${API_URL}/api/journalingquestions/question`,
        {
          id: reqId,
        },
        headerWithToken
      );
      return { success: true, data: res };
    } catch (error) {
      // console.log('asdasasdas', res);
      return { success: false };
    }
  }, []);

  const getSingleArticleApi = useCallback(async (reqId) => {
    try {
      const res = await axios.post(
        `${API_URL}/api/articles/article`,
        {
          id: reqId,
        },
        headerWithToken
      );
      return { success: true, data: res };
    } catch (error) {
      // console.log('asdasasdas', res);
      return { success: false };
    }
  }, []);

  const getSingleSessionApi = useCallback(async (reqId) => {
    try {
      const res = await axios.post(
        `${API_URL}/api/programs/session`,
        {
          id: reqId,
        },
        headerWithToken
      );
      return { success: true, data: res };
    } catch (error) {
      // console.log('asdasasdas', res);
      return { success: false };
    }
  }, []);

  const createProgramApi = useCallback(async (reqData) => {
    console.log(reqData.form);
    try {
      const res = await axios.post(`${API_URL}/api/programs/add`, reqData.form, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      dispatch({ type: types.UPDATE_ALL_PROGRAMS, payload: res.data.result });
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: { color: "success", title: "Program Created successfully!", errorSB: true },
      });
      return { success: true };
    } catch (error) {
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: { color: "error", title: "Something Went Wrong!", errorSB: true },
      });
      return { success: false };
    }
  }, []);

  const createSoundscapeApi = useCallback(async (reqData) => {
    console.log(reqData.form);
    try {
      const res = await axios.post(`${API_URL}/api/soundscapes/add`, reqData.form, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      dispatch({ type: types.UPDATE_ALL_SOUNDSCAPES, payload: res.data.result });
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: { color: "success", title: "Soundscape Created successfully!", errorSB: true },
      });
      return { success: true };
    } catch (error) {
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: { color: "error", title: "Something Went Wrong!", errorSB: true },
      });
      return { success: false };
    }
  }, []);

  const createSleepApi = useCallback(async (reqData) => {
    console.log(reqData.form);
    try {
      const res = await axios.post(`${API_URL}/api/sleepprograms/add`, reqData.form, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      dispatch({ type: types.UPDATE_ALL_SLEEP_PROGRAMS, payload: res.data.result });
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: { color: "success", title: "Sleep Program Created successfully!", errorSB: true },
      });
      return { success: true };
    } catch (error) {
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: { color: "error", title: "Something Went Wrong!", errorSB: true },
      });
      return { success: false };
    }
  }, []);

  const createBreatheApi = useCallback(async (reqData) => {
    console.log(reqData.form);
    try {
      const res = await axios.post(`${API_URL}/api/breatheprograms/add`, reqData.form, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      dispatch({ type: types.UPDATE_ALL_BREATHE_PROGRAMS, payload: res.data.result });
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: {
          color: "success",
          title: "Breathe Program Created successfully!",
          errorSB: true,
        },
      });
      return { success: true };
    } catch (error) {
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: { color: "error", title: "Something Went Wrong!", errorSB: true },
      });
      return { success: false };
    }
  }, []);

  const createQuoteApi = useCallback(async (reqData) => {
    console.log(reqData);
    try {
      const res = await axios.post(`${API_URL}/api/quotes/add`, {
        id: reqData.id,
        quote: reqData.quote,
        author: reqData.author,
        created_on: reqData.created_on,
      });
      dispatch({ type: types.UPDATE_ALL_QUOTES, payload: res.data.result });
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: {
          color: "success",
          title: "Quote Created successfully!",
          errorSB: true,
        },
      });
      return { success: true };
    } catch (error) {
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: { color: "error", title: "Something Went Wrong!", errorSB: true },
      });
      return { success: false };
    }
  }, []);

  const createArticleApi = useCallback(async (reqData) => {
    console.log(reqData);
    try {
      const res = await axios.post(`${API_URL}/api/articles/add`, reqData.form, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      dispatch({ type: types.UPDATE_ALL_ARTICLES, payload: res.data.result });
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: {
          color: "success",
          title: "Article Created successfully!",
          errorSB: true,
        },
      });
      return { success: true };
    } catch (error) {
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: { color: "error", title: "Something Went Wrong!", errorSB: true },
      });
      return { success: false };
    }
  }, []);

  const updateArticleApi = useCallback(async (reqData) => {
    try {
      await axios.post(`${API_URL}/api/articles/update`, reqData.form, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      getArticlesApi();
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: {
          color: "success",
          title: "Article Updated successfully!",
          errorSB: true,
        },
      });
      return { success: true };
    } catch (error) {
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: { color: "error", title: "Something Went Wrong!", errorSB: true },
      });
      return { success: false };
    }
  }, []);

  const createQuestionApi = useCallback(async (reqData) => {
    console.log(reqData);
    try {
      const res = await axios.post(`${API_URL}/api/journalingquestions/add`, {
        id: reqData.id,
        question: reqData.question,
        description: reqData.description,
        created_on: reqData.created_on,
      });
      dispatch({ type: types.UPDATE_ALL_JOURNAL_QUESTIONS, payload: res.data.result });
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: {
          color: "success",
          title: "Question Created successfully!",
          errorSB: true,
        },
      });
      return { success: true };
    } catch (error) {
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: { color: "error", title: "Something Went Wrong!", errorSB: true },
      });
      return { success: false };
    }
  }, []);

  const updateQuestionApi = useCallback(async (reqData) => {
    try {
      await axios.post(
        `${API_URL}/api/journalingquestions/update`,
        {
          id: reqData.id,
          question: reqData.question,
          description: reqData.description,
          created_on: reqData.created_on,
        },
        headerWithToken
      );
      getQuotesApi();
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: {
          color: "success",
          title: "Question Updated successfully!",
          errorSB: true,
        },
      });
      return { success: true };
    } catch (error) {
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: { color: "error", title: "Something Went Wrong!", errorSB: true },
      });
      return { success: false };
    }
  }, []);

  const updateQuoteApi = useCallback(async (reqData) => {
    try {
      await axios.post(
        `${API_URL}/api/quotes/update`,
        {
          id: reqData.id,
          quote: reqData.quote,
          author: reqData.author,
          created_on: reqData.created_on,
        },
        headerWithToken
      );
      getQuotesApi();
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: {
          color: "success",
          title: "Quote Updated successfully!",
          errorSB: true,
        },
      });
      return { success: true };
    } catch (error) {
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: { color: "error", title: "Something Went Wrong!", errorSB: true },
      });
      return { success: false };
    }
  }, []);

  const updateBreatheApi = useCallback(async (reqData) => {
    try {
      await axios.post(
        `${API_URL}/api/breatheprograms/update`,
        reqData.form,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
        headerWithToken
      );
      getBreathesApi();
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: {
          color: "success",
          title: "Breathe Program Updated successfully!",
          errorSB: true,
        },
      });
      return { success: true };
    } catch (error) {
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: { color: "error", title: "Something Went Wrong!", errorSB: true },
      });
      return { success: false };
    }
  }, []);

  const updateSleepApi = useCallback(async (reqData) => {
    try {
      await axios.post(
        `${API_URL}/api/sleepprograms/update`,
        reqData.form,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
        headerWithToken
      );
      getSleepsApi();
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: { color: "success", title: "Sleep Program Updated successfully!", errorSB: true },
      });
      return { success: true };
    } catch (error) {
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: { color: "error", title: "Something Went Wrong!", errorSB: true },
      });
      return { success: false };
    }
  }, []);

  const updateSoundscapeApi = useCallback(async (reqData) => {
    try {
      await axios.post(
        `${API_URL}/api/soundscapes/update`,
        reqData.form,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
        headerWithToken
      );
      getSoundscapesApi();
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: { color: "success", title: "Soundscape Updated successfully!", errorSB: true },
      });
      return { success: true };
    } catch (error) {
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: { color: "error", title: "Something Went Wrong!", errorSB: true },
      });
      return { success: false };
    }
  }, []);

  const updateProgramApi = useCallback(async (reqData) => {
    try {
      await axios.post(
        `${API_URL}/api/programs/update`,
        reqData.form,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
        headerWithToken
      );
      getProgramsApi();
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: { color: "success", title: "Program Updated successfully!", errorSB: true },
      });
      return { success: true };
    } catch (error) {
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: { color: "error", title: "Something Went Wrong!", errorSB: true },
      });
      return { success: false };
    }
  }, []);

  const addSessionApi = useCallback(async (reqData) => {
    console.log(reqData);
    try {
      await axios.post(
        `${API_URL}/api/programs/addsession`,
        reqData.form,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
        headerWithToken
      );
      getSessionsApi(reqData.program);
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: { color: "success", title: "Session Added!", errorSB: true },
      });
      return { success: true };
    } catch (error) {
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: { color: "error", title: "Something Went Wrong!", errorSB: true },
      });
      return { success: false };
    }
  }, []);

  const updateSessionApi = useCallback(async (reqData) => {
    try {
      await axios.post(
        `${API_URL}/api/programs/updatesession`,
        reqData.form,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
        headerWithToken
      );
      getSessionsApi(reqData.program);
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: { color: "success", title: "Session Updated successfully!", errorSB: true },
      });
      return { success: true };
    } catch (error) {
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: { color: "error", title: "Something Went Wrong!", errorSB: true },
      });
      return { success: false };
    }
  }, []);

  const deleteSingleProgramApi = useCallback(async (reqId) => {
    try {
      await axios.delete(`${API_URL}/api/programs/delete`, {
        headerWithToken,
        data: {
          id: reqId,
        },
      });
      dispatch({ type: types.DELETE_SINGLE_PROGRAMS, payload: reqId });
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: { color: "success", title: "Program Deleted successfully!", errorSB: true },
      });
    } catch (error) {
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: { color: "error", title: "Something Went Wrong!", errorSB: true },
      });
    }
  }, []);

  const deleteSingleSoundscapeApi = useCallback(async (reqId) => {
    try {
      await axios.delete(`${API_URL}/api/soundscapes/delete`, {
        headerWithToken,
        data: {
          id: reqId,
        },
      });
      dispatch({ type: types.DELETE_SINGLE_SOUNDSCAPES, payload: reqId });
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: { color: "success", title: "Soundscape Deleted successfully!", errorSB: true },
      });
    } catch (error) {
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: { color: "error", title: "Something Went Wrong!", errorSB: true },
      });
    }
  }, []);

  const deleteSingleSleepApi = useCallback(async (reqId) => {
    try {
      await axios.delete(`${API_URL}/api/sleepprograms/delete`, {
        headerWithToken,
        data: {
          id: reqId,
        },
      });
      dispatch({ type: types.DELETE_SINGLE_SLEEP_PROGRAMS, payload: reqId });
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: { color: "success", title: "Sleep Program Deleted successfully!", errorSB: true },
      });
    } catch (error) {
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: { color: "error", title: "Something Went Wrong!", errorSB: true },
      });
    }
  }, []);

  const deleteSingleBreatheApi = useCallback(async (reqId) => {
    try {
      await axios.delete(`${API_URL}/api/breatheprograms/delete`, {
        headerWithToken,
        data: {
          id: reqId,
        },
      });
      dispatch({ type: types.DELETE_SINGLE_BREATHE_PROGRAMS, payload: reqId });
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: {
          color: "success",
          title: "Breathe Program Deleted successfully!",
          errorSB: true,
        },
      });
    } catch (error) {
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: { color: "error", title: "Something Went Wrong!", errorSB: true },
      });
    }
  }, []);

  const deleteSingleQuoteApi = useCallback(async (reqId) => {
    try {
      await axios.delete(`${API_URL}/api/quotes/delete`, {
        headerWithToken,
        data: {
          id: reqId,
        },
      });
      dispatch({ type: types.DELETE_SINGLE_QUOTES, payload: reqId });
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: {
          color: "success",
          title: "Quote Deleted successfully!",
          errorSB: true,
        },
      });
    } catch (error) {
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: { color: "error", title: "Something Went Wrong!", errorSB: true },
      });
    }
  }, []);

  const deleteSingleQuestionApi = useCallback(async (reqId) => {
    try {
      await axios.delete(`${API_URL}/api/journalingquestions/delete`, {
        headerWithToken,
        data: {
          id: reqId,
        },
      });
      dispatch({ type: types.DELETE_SINGLE_JOURNAL_QUESTIONS, payload: reqId });
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: {
          color: "success",
          title: "Question Deleted successfully!",
          errorSB: true,
        },
      });
    } catch (error) {
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: { color: "error", title: "Something Went Wrong!", errorSB: true },
      });
    }
  }, []);

  const deleteSingleArticleApi = useCallback(async (reqId) => {
    try {
      await axios.delete(`${API_URL}/api/articles/delete`, {
        headerWithToken,
        data: {
          id: reqId,
        },
      });
      dispatch({ type: types.DELETE_SINGLE_ARTICLES, payload: reqId });
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: {
          color: "success",
          title: "Article Deleted successfully!",
          errorSB: true,
        },
      });
    } catch (error) {
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: { color: "error", title: "Something Went Wrong!", errorSB: true },
      });
    }
  }, []);

  const deleteSingleSessionApi = useCallback(async (reqId) => {
    try {
      await axios.delete(`${API_URL}/api/programs/deletesession`, {
        headerWithToken,
        data: {
          id: reqId,
        },
      });
      dispatch({ type: types.DELETE_SINGLE_SESSIONS, payload: reqId });
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: { color: "success", title: "Session Deleted successfully!", errorSB: true },
      });
    } catch (error) {
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: { color: "error", title: "Something Went Wrong!", errorSB: true },
      });
    }
  }, []);

  // const uploadSoundscapeApi = useCallback(async (reqData) => {
  //   console.log(reqData);
  //   try {
  //     await axios.post(`${API_URL}/api/soundscapes/uploadaudio`, reqData.form, {
  //       headers: {
  //         "Content-Type": "multipart/form-data",
  //       },
  //     });
  //     dispatch({
  //       type: types.SHOW_SNACKBAR_ALERT,
  //       payload: { color: "success", title: "Audio Uploaded!", errorSB: true },
  //     });
  //     return { success: true };
  //   } catch (error) {
  //     dispatch({
  //       type: types.SHOW_SNACKBAR_ALERT,
  //       payload: { color: "error", title: "Something Went Wrong!", errorSB: true },
  //     });
  //     return { success: false };
  //   }
  // }, []);

  // const uploadProgramSessionAudioApi = useCallback(async (reqData) => {
  //   console.log(reqData);
  //   try {
  //     await axios.post(
  //       `${API_URL}/api/uploadprogramsession`,
  //       {
  //         id: reqData.id,
  //         slug: reqData.slug,
  //         audio: reqData.audio,
  //       },
  //       headerWithToken
  //     );
  //     getProgramsApi();
  //     dispatch({
  //       type: types.SHOW_SNACKBAR_ALERT,
  //       payload: { color: "success", title: "Audio Added!", errorSB: true },
  //     });
  //     return { success: true };
  //   } catch (error) {
  //     dispatch({
  //       type: types.SHOW_SNACKBAR_ALERT,
  //       payload: { color: "error", title: "Something Went Wrong!", errorSB: true },
  //     });
  //     return { success: false };
  //   }
  // }, []);

  const createUserApi = useCallback(async (reqData) => {
    try {
      const res = await axios.post(`${API_URL}/api/users/register`, {
        // id: uuidvNumbers(),
        user_id: reqData.user_id,
        user_email: reqData.user_email,
        user_number: reqData.user_number,
        user_password: reqData.user_password,
        user_first_name: reqData.user_first_name,
        user_last_name: reqData.user_last_name,
        user_type: reqData.user_type,
        login_type: reqData.login_type,
        premium: reqData.premium,
        user_activated: reqData.user_activated,
      });
      dispatch({ type: types.UPDATE_ALL_USERS, payload: res.data.result });
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: { color: "success", title: "User Created successfully!", errorSB: true },
      });
      return { success: true };
    } catch (error) {
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: { color: "error", title: "Something Went Wrong!", errorSB: true },
      });
      return { success: false };
    }
  }, []);

  const updateUserApi = useCallback(async (reqData) => {
    try {
      await axios.post(
        `${API_URL}/api/users/saveprofile`,
        {
          user_first_name: reqData.firstName,
          user_last_name: reqData.lastName,
          user_email: reqData.email,
          user_type: reqData.role,
          user_number: reqData.phone,
        },
        headerWithToken
      );
      getUsersApi();
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: { color: "success", title: "User Updated successfully!", errorSB: true },
      });
      return { success: true };
    } catch (error) {
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: { color: "error", title: "Something Went Wrong!", errorSB: true },
      });
      return { success: false };
    }
  }, []);

  const deleteSingleUserApi = useCallback(async (reqId) => {
    try {
      await axios.delete(`${API_URL}/api/users/delete`, {
        headerWithToken,
        data: {
          user_email: reqId,
        },
      });
      dispatch({ type: types.DELETE_SINGLE_USERS, payload: reqId });
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: { color: "success", title: "User Deleted successfully!", errorSB: true },
      });
    } catch (error) {
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: { color: "error", title: "Something Went Wrong!", errorSB: true },
      });
    }
  }, []);

  const deleteSinglePatientApi = useCallback(async (reqId) => {
    try {
      await axios.delete(`${API_URL}/api/patients/delete`, {
        headerWithToken,
        data: {
          id: reqId,
        },
      });
      dispatch({ type: types.DELETE_SINGLE_PATIENTS, payload: reqId });
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: { color: "success", title: "Patient Deleted successfully!", errorSB: true },
      });
    } catch (error) {
      dispatch({
        type: types.SHOW_SNACKBAR_ALERT,
        payload: { color: "error", title: "Something Went Wrong!", errorSB: true },
      });
    }
  }, []);

  const sendMail = useCallback(async (reqData) => {
    try {
      const res = await axios.post(`${API_URL}/api/mails/sendreset`, {
        to: reqData.to,
        body: reqData.body,
        subject: reqData.subject,
        code: reqData.code,
      });
      return { success: true };
    } catch (error) {
      return { success: false };
    }
  }, []);

  useEffect(() => {
    getProgramsApi();
    getSoundscapesApi();
    getUsersApi();
    getSleepsApi();
    getBreathesApi();
    getQuotesApi();
    getQuestionsApi();
    getArticlesApi();
    getDoctorUsersApi();
    getPatientsApi();
    getIPDPatientsApi();
    getOPDPatientsApi();
    // getItemGroupsApi();
    // getAccountsApi();
    // getStampsApi();
    // getAccountGroupsApi();
    // getVoucherApi();
    // getSalesApi();
    // getStockApi()
    // getTagsByVoucherApi()
    // getItemGroupStockApi()
    // getTagsApi()
    // getPaymentsApi()
  }, []);

  return (
    <DataContext.Provider
      value={{
        dataState,
        createProgramApi,
        updateProgramApi,
        getSingleProgramApi,
        deleteSingleProgramApi,
        getProgramsApi,

        createSoundscapeApi,
        updateSoundscapeApi,
        getSingleSoundscapeApi,
        deleteSingleSoundscapeApi,
        getSoundscapesApi,

        createSleepApi,
        updateSleepApi,
        getSingleSleepApi,
        deleteSingleSleepApi,
        getSleepsApi,

        createBreatheApi,
        updateBreatheApi,
        getSingleBreatheApi,
        deleteSingleBreatheApi,
        getBreathesApi,

        createQuoteApi,
        updateQuoteApi,
        getSingleQuoteApi,
        deleteSingleQuoteApi,
        getQuotesApi,

        createQuestionApi,
        updateQuestionApi,
        getSingleQuestionApi,
        deleteSingleQuestionApi,
        getQuestionsApi,

        createArticleApi,
        updateArticleApi,
        getSingleArticleApi,
        deleteSingleArticleApi,
        getArticlesApi,

        addSessionApi,
        updateSessionApi,
        deleteSingleSessionApi,
        getSingleSessionApi,
        getSessionsApi,

        getDoctorUsersApi,
        getPatientsApi,

        getUsersApi,
        createUserApi,
        updateUserApi,
        deleteSingleUserApi,
        deleteSinglePatientApi,

        sendMail,

        closeSnackbarAlert,
        myDispatch,
      }}
    >
      {" "}
      {children}{" "}
    </DataContext.Provider>
  );
};
